export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.001 5.1a.9.9 0 0 0-.9.9v3.1H8a.901.901 0 0 0 0 1.8h3.1V16a.901.901 0 0 0 1.8 0v-3.1H16a.9.9 0 0 0 0-1.8h-3.1V8a.9.9 0 0 0-.9-.9Z"/>
</svg>
`;
